import { render, staticRenderFns } from "./OrderTagManager.vue?vue&type=template&id=5cd55db7&scoped=true"
import script from "./OrderTagManager.vue?vue&type=script&lang=js"
export * from "./OrderTagManager.vue?vue&type=script&lang=js"
import style0 from "./OrderTagManager.vue?vue&type=style&index=0&id=5cd55db7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd55db7",
  null
  
)

export default component.exports